// roleIdSlice.js
import {createSlice} from '@reduxjs/toolkit';

const roleIdSlice = createSlice({
  name: 'roleIdValue',
  initialState: {
    roleId: null,
  },
  reducers: {
    setRoleIdValue: (state, action) => {
      state.roleId = action.payload;
    },
    clearRoleIdValue: state => {
      state.roleId = null;
    },
  },
});

export const {setRoleIdValue, clearRoleIdValue} = roleIdSlice.actions;
export default roleIdSlice.reducer;
